import { Dialog, DialogPanel } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import IconSvg from 'src/assets/icons/IconSvg';

interface Props {
  isOpen: boolean;
  transactionLink?: string;
}

const RaffleSuccessModal = ({ isOpen, transactionLink }: Props) => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/profile?tab=createdRaffles');
  };

  return (
    <Dialog open={isOpen} as="div" className="relative z-50 focus:outline-none" onClose={handleClose}>
      <div className="fixed inset-0 bg-[#1B1B1F99] backdrop-blur-[6.3px]" />

      <div className="overflow-y-auto fixed inset-0 w-screen">
        <div className="flex justify-center items-center min-h-full p-4">
          <DialogPanel className="w-full max-w-[637px] rounded-lg bg-grayscale-900 p-10 relative flex flex-col gap-[26px] items-center">
            <button className="absolute top-5 right-5" onClick={handleClose}>
              <IconSvg icon="closeM" className="text-grayscale-400" />
            </button>

            <div className="flex flex-col gap-2 items-center text-center max-w-[527px]">
              <h3 className="text-brand-magnolia text-[32px] font-semibold font-['Poppins'] leading-[43px]">
                Congratulations
              </h3>

              <p className="text-lg text-grayscale-400 leading-[26px]">
                Your raffle is being setup and will be live once confirmed. You can track the status of the raffle via Profiles.
              </p>
            </div>

            {transactionLink && (
              <a
                href={transactionLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-lg text-brand-tangerine underline leading-[24px]"
              >
                Transaction Link
              </a>
            )}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default RaffleSuccessModal;
